import React from "react";
import styled from "styled-components";
import { CustomLabel, BookAppointmentButton } from "../../Common/style";
import { Row, Col, Button } from "antd";
import { markerIcon, callIcon } from "../../Assets/Images";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";

export const StyledCenterCard = styled.div`
  width: 100%;
  height: auto;
  margin: 20px 70px 30px 1px;
  padding: 29px 30px 30px 29px;
  object-fit: contain;
  border-radius: 10px;
  box-shadow: 0 0 21px 0 #33333319;
  @media (max-width:767px){
    padding: 20px 22px 20px 20px;
  }
`;


 const DiagnosticCenter = ({name, address, contactNo, pinCode, onBookAppointmentClick, btnText }) => {
  return (
    <StyledCenterCard>
      <Row>
        <CustomLabel font_size="16" font_weight="bold">
          {name}
        </CustomLabel>
      </Row>
      <Row gutter={[12, 10]}>
        <Col xs={24} md={20} lg={13} style={{ marginTop: "16px" }}>
          <Row>
            <Col xs={2}>
              <img src={markerIcon} />
            </Col>
            <Col xs={16} sm={18} md={22} >
              <CustomLabel font_size="14" font_weight="normal">
                {address + pinCode}
              </CustomLabel>
            </Col>
          </Row>
          {contactNo && <Row>
            <Col xs={2} style={{ marginTop: "12px" }}>
              <img src={callIcon} />
            </Col>
            <Col xs={16} sm={18} md={12} style={{ marginTop: "12px" }}>
              <CustomLabel font_size="14" font_weight="normal">
                {contactNo}
              </CustomLabel>
            </Col>
          </Row>}
        </Col>
        <Col xs={24} md={12} lg={11} className="justify-flex-end">
          <BookAppointmentButton disable={false}>
            <Button onClick={onBookAppointmentClick} type="text" disabled={false}>
                {btnText}
                <FontAwesomeIcon
                  icon={faAngleRight}
                  style={{ marginLeft: "15px" }}
                />
              </Button>
          </BookAppointmentButton>
        </Col>
      </Row>
    </StyledCenterCard>
  );
};

export default DiagnosticCenter;